export default "__VITE_ASSET__ad2ec326__"